module.exports = __webpack_public_path__ + "static/media/volunteer-cover.9f108401.png";